import { useEffect, useRef } from 'react'
import { Flex, Text, Button } from 'rebass/styled-components'
import { useCreateClinicalTeamConversation } from '../../../../graphql/hooks/mutations/useCreateClinicalTeamConversation';
import { toast } from 'react-toastify';

interface INoClinicalTeamConversationProps {
  athenaId: string,
  refetchClinicalTeamConversationId:()=>void
}

export const NoClinicalTeamConversation: React.FC<INoClinicalTeamConversationProps> = ({ athenaId, refetchClinicalTeamConversationId }) => {
  const toastId = useRef<any>(null);

  useEffect(() => {
    return () => {
      if (toastId && toastId.current) {
        toast.dismiss(toastId.current)
      }
    }
  }, [])
  
  const { mutate: createConversation, loading: loadingCreateConvo, data: dataCreateConvo } = useCreateClinicalTeamConversation({
    athenaId,
    onError: ({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {

          if (!!toastId && toastId.current) {
            toast.update(toastId.current, {
              render: `${message || 'An error occured'}`.replace('Error: ', ''),
              type: toast.TYPE.ERROR,
              isLoading: false,
              autoClose: 7000,
              closeButton: null // The closeButton defined on ToastContainer will be used
            });
          } else {
            toast.error(`${message || 'An error occured'}`.replace('Error: ', ''))
          }
        }
        );
      } else {
        if (!!toastId && toastId.current) {
          toast.update(toastId.current, {
            render: 'An error occured',
            type: toast.TYPE.ERROR,
            isLoading: false,
            autoClose: 7000,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
        } else {
          toast.error(`${'An error occured'}`)
        }
      }
    },
    onCompleted: () => {
      if (!!toastId && toastId.current) {
        refetchClinicalTeamConversationId()
        toast.update(toastId.current, {
          render: 'Clinical Team conversation created successfully',
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.success('Clinical Team conversation created successfully')
      }
    }
  })

  const create = () => {
    toastId.current = toast(<Flex flexDirection={'column'}>
      <Text fontWeight={400}>Creating Clinical Team conversation</Text>
      <Text fontWeight={300}>Please wait</Text>
    </Flex>, { autoClose: false, isLoading: true, closeButton: false });
    createConversation()
  }
  return (
    <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'} flex={1}>
      <Text maxWidth={'63%'} textAlign={'center'} mb={4}>No Clinical Team conversation exists. You can start one by clicking the button below:</Text>
      <Button onClick={create} disabled={!!loadingCreateConvo}>
        Create Conversation
      </Button>
    </Flex>);
}